<template>
  <div id="logos">
    <div class="stripe stripe--top">
      <h1>Välkommen till<br>Frösundavik!</h1>
    </div>
    <section>
      <div class="images">
        <template v-if="perRow === 2">
          <div>
            <div><img src="./assets/logo/avm.svg" style="height: 150px;" /></div>
          </div>
          <div>
            <div><img src="./assets/logo/unicarriers.svg" style="height: 80px;" /></div>
          </div>
        </template>
        <template v-if="perRow === 3">
          <div>
            <div><img src="./assets/logo/accord.svg" style="height: 50px;" /></div>
            <div><img src="./assets/logo/actic.svg" style="height: 90px;" /></div>
            <div><img src="./assets/logo/andritz.svg" style="height: 40px;" /></div>
          </div>
          <div>
            <div><img src="./assets/logo/brunswick.svg" style="height: 55px;" /></div>
            <div><img src="./assets/logo/commvault.svg" style="height: 125px;" /></div>
            <div><img src="./assets/logo/compass.svg" style="height: 100px;" /></div>
          </div>
          <div>
            <div><img src="./assets/logo/Constrera.jpg" style="height: 65px;" /></div>
            <div><img src="./assets/logo/enaco.svg" style="height: 50px;" /></div>
            <div><img src="./assets/logo/ford.svg" style="height: 73px;" /></div>
          </div>
          <div>
            <div><img src="./assets/logo/lufthansa.svg" style="height: 53px;" /></div>
            <div><img src="./assets/logo/merck.svg" style="height: 40px;" /></div>
            <div><img src="./assets/logo/pharma.svg" style="height: 65px;" /></div>
          </div>
          <div>
            <div><img src="./assets/logo/plaza.svg" style="height: 43px;" /></div>
            <div><img src="./assets/logo/sas.png" style="height: 55px;" /></div>
            <div><img src="./assets/logo/schneider.svg" style="height: 50px;" /></div>
          </div>
          <div>
            <div><img src="./assets/logo/servicenow.svg" style="height: 43px;" /></div>
            <div><img src="./assets/logo/servier.svg" style="height: 73px;" /></div>
            <div><img src="./assets/logo/shibuya.svg" style="height: 73px;" /></div>
          </div>
          <div>
            <div><img src="./assets/logo/unicarriers.svg" style="height: 40px;" /></div>
            <div><img src="./assets/logo/Wacker_Chemie.png" style="height: 60px;" /></div>
            <div>&nbsp;</div>
          </div>
        </template>
        <template v-if="perRow === 5">
          <div>
            <div><img src="./assets/logo/accord.svg" style="height: 50px;" /></div>
            <div><img src="./assets/logo/actic.svg" style="height: 90px;" /></div>
            <div><img src="./assets/logo/andritz.svg" style="height: 40px;" /></div>
            <div><img src="./assets/logo/brunswick.svg" style="height: 55px;" /></div>
            <div><img src="./assets/logo/commvault.svg" style="height: 125px;" /></div>
          </div>
          <div>
            <div><img src="./assets/logo/compass.svg" style="height: 100px;" /></div>
            <div><img src="./assets/logo/Constrera.jpg" style="height: 65px;" /></div>
            <div><img src="./assets/logo/enaco.svg" style="height: 50px;" /></div>
            <div><img src="./assets/logo/ford.svg" style="height: 73px;" /></div>
            <div><img src="./assets/logo/lufthansa.svg" style="height: 53px;" /></div>
          </div>
          <div>
            <div><img src="./assets/logo/merck.svg" style="height: 40px;" /></div>
            <div><img src="./assets/logo/pharma.svg" style="height: 65px;" /></div>
            <div><img src="./assets/logo/plaza.svg" style="height: 43px;" /></div>
            <div><img src="./assets/logo/sas.png" style="height: 55px;" /></div>
            <div><img src="./assets/logo/schneider.svg" style="height: 50px;" /></div>
          </div>
          <div>
            <div><img src="./assets/logo/servicenow.svg" style="height: 43px;" /></div>
            <div><img src="./assets/logo/servier.svg" style="height: 73px;" /></div>
            <div><img src="./assets/logo/shibuya.svg" style="height: 73px;" /></div>
            <div><img src="./assets/logo/unicarriers.svg" style="height: 40px;" /></div>
            <div><img src="./assets/logo/Wacker_Chemie.png" style="height: 60px;" /></div>
          </div>
        </template>
      </div>
    </section>
    <div class="stripe stripe--bottom"></div>
  </div>
</template>

<script>

export default {
  props: {
    perRow: {
      type: Number,
      required: false,
      default: 3
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  beforeDestroy () {
  },
  methods: {
  },
  components: {
  }
}
</script>

<style lang="scss">
  @import 'style/app.scss';
  body, html {
    height: 100%;
    overflow: hidden;
  }
  #logos {
    height: 100%;
    background: white;
    h1 {
      font-family: 'Paytone One';
      font-size: 100px;
      font-weight: 400;
      letter-spacing: 4px;
      line-height: 1.2;
      text-align: center;
      margin: 0;
      padding: 11rem;
    }

    .images {
        display: table;
        margin: 0 auto;
        > div {
          display: table-row;
          vertical-align: middle;
          > div {
            display: table-cell;
            width: 290px;
            padding: 50px 20px;
            text-align: center;
          }
        }
        img {
          vertical-align: middle;
        }
    }

    .stripe {
      background: #99bbc5;
      &--top {
        top: 0;
        left: 0;
        width: 100%;
      }
      &--bottom {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 200px;
        width: 100%;
      }

    }

    color: white;
    padding: 0;
  }
</style>
